import { Component, Output, EventEmitter, OnInit } from '@angular/core';

/**
   * Logger Factory
   * @namespace dateSelected: is the date selected to brought to his parent
   * <ute-timepicker class="" (hourSelected)="test($event)"></ute-timepicker>
*/

@Component({
  selector: 'ute-timepicker',
  templateUrl: 'ute-timepicker.component.html'
})
export class UteTimepickerComponent implements OnInit{
  @Output() hourSelected = new EventEmitter;

  public time: any;
  public placeholder: any;

  constructor() {}

  ngOnInit(){
    this.placeholder = "00:00";
  }

  onChangeTime(event){
    this.hourSelected.emit(event);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-timepicker/ute-timepicker.component.ts